import React, {useRef} from 'react';
import Grid from '../Grid';
import FormDialog from '../form/form-dialog';
import FormInput from '../form/form-input';
import StatusMessage from '../StatusMessage';
import { ConfigContext } from '../Config/ConfigContext';


import useForm from '../hooks/useForm';

import {
    http,
} from '../utils';

import {useNavigate} from 'react-router-dom';
import {
    Container,
    Box
} from '@mui/system';

import {
    Button, 
} from '@mui/material';

import {
    isEmpty
} from 'lodash';

const addApplicationSubmit = async ({
    values, 
    onFail, 
    onInvalidForm, 
    onChangeBulk,
    onResetFormErrors,
}) => {
    onChangeBulk({
        statusType: '',
        statusMessage: '',
    });

    let errors = {};
    
    if (!values.applicationName) errors.applicationName = 'Application Name must be populated';
    if (!values.appId) errors.appId = 'Application Id must be populated';
    if (!isEmpty(errors)) return onInvalidForm(errors);

    onResetFormErrors();

    const result = await http.post({
        applicationName: values.applicationName,
        appId: values.appId,
        refreshInterval: values.refreshInterval
    }, `${values.config.uri.base}/application`);
    
    if (result.errored) 
        return onFail(result);

    onChangeBulk({
        applicationName: '',
        appId: '',
        refreshInterval:'',
        modalToggle: false,
        statusType: 'success',
        statusMessage: `Successfully saved new Site: ${values.applicationName}`,
        _id: result._id
    });

};


export default function Sites() {
    const navigate = useNavigate(); 
    const {config} = React.useContext(ConfigContext)
    const gridRef = useRef();
    const {
        state,
        onChange,
        onInvalidForm,
        onFail,
        onChangeBulk,
        onResetFormErrors,
    } = useForm({
        initialState:{
            modalToggle: false,
            config,
            applicationName: '',
            appId: '',
            statusType: '',
            statusMessage: '',
        },
    });
   
    const handleCloseModal = () => {
        onChange(!state.values.modalToggle, 'modalToggle');
    }

    return (
        <Container
            sx={{marginTop: '20px'}}
        >
            { state.values.statusType &&
                <StatusMessage 
                    messageType={state.values.statusType}
                    message={state.values.statusMessage}
                />
            }

            {
                state.values.modalToggle &&
                <FormDialog
                    dialogTitle={'Add Application'}
                    dialogSubHeading={'Fill out this form to add a new site to begin tracking site copy changes'}
                    isOpen={state.values.modalToggle}
                    handleClose={handleCloseModal}
                    handleSubmit={async () => { 
                        await addApplicationSubmit({
                            values: state.values,
                            onInvalidForm,
                            onFail,
                            onChangeBulk,
                            onResetFormErrors,
                        });
                        gridRef.current.onRefresh();
                    }}
                >
                    <Box
                        sx={{display: 'flex', flexDirection: 'column'}}
                    >
                        <FormInput
                            label='Application Name'
                            path='applicationName'
                            value={state.values.applicationName}
                            error={state.errors.applicationName}
                            onChange={onChange}
                        />
                        <FormInput
                            label='App Id'
                            path='appId'
                            value={state.values.appId}
                            error={state.errors.appId}
                            onChange={onChange}
                        />
                    </Box>
                </FormDialog>
            }

            <Box
                sx={{display: 'flex', justifyContent: 'flex-end'}}
            >
                <Button
                    variant={'contained'}
                    onClick={() => onChange(!state.values.modalToggle, 'modalToggle')} >Add Application</Button>
            </Box>
            <Grid
                ref={gridRef}
                tableName={'Applications'}
                searchEndpont={`${config.uri.base}/application`}
                actionRowClick={({rowData}) => navigate(`/application/${rowData._id}`)}
                actionDelete={async ()=> {
                    //const body =  {
                    //    where:{
                    //        id:selectedRows,
                    //    },
                    //    values:{
                    //        deleted:true
                    //    }
                    //};

                    //await siteCopySite.bulkUpdate(body);

                    location.reload()
                }}
                headCells={[
                    {
                        id: 'name',
                        numeric: false,
                        disablePadding: true,
                        label: 'Application Name',
                    },
                    {
                        id: 'appId',
                        numeric: false,
                        disablePadding: true,
                        label: 'App Id',
                    },

                    {
                        id: 'deleted',
                        numeric: false,
                        disablePadding: true,
                        label: 'Is Deleted'
                    },
                ]}
                filterList={[
                    {
                        id: 'name',
                        dataType: 'string',
                        label: 'Application Name',
                        defaultValue: ''
                    },
                    {
                        id: 'appId',
                        dataType: 'string',
                        label: 'App Id',
                        defaultValue: ''
                    },
                    {
                        id: 'deleted',
                        dataType: 'boolean',
                        label: 'Is Deleted',
                        defaultValue: false
                    }
                ]}
            />
        </Container>
    );
}

